export default class ClubOfferingSettings {

    static INSTRUCTOR_NAME_VISIBILITY_FIRST_AND_LAST_NAME = 'first_and_last_name';
    static INSTRUCTOR_NAME_VISIBILITY_FIRST_NAME_ONLY = 'first_name_only';
    static INSTRUCTOR_NAME_VISIBILITY_FIRST_NAME_AND_FIRST_LETTER_OF_LAST_NAME = 'first_name_and_first_letter_of_last_name';

    static fromData(data) {
        if (!data) {
            return;
        }

        const clubOfferingSettings = new ClubOfferingSettings();
        clubOfferingSettings.showInFrontends = data.showInFrontends;
        clubOfferingSettings.conditionsOfParticipationUrl = data.conditionsOfParticipationUrl || '';
        clubOfferingSettings.clubFeeCategories = data.clubFeeCategories;
        clubOfferingSettings.notificationPeriod = {
            'start':  data.notificationPeriod.start,
            'end':  data.notificationPeriod.end,
        };
        clubOfferingSettings.instructorNameVisibility = data.instructorNameVisibility;

        return clubOfferingSettings;
    }

    serialize() {
        return {
            showInFrontends: this.showInFrontends,
            conditionsOfParticipationUrl: this.conditionsOfParticipationUrl,
            clubFeeCategories: this.clubFeeCategories.map(category => {
                return {
                    id: category.id,
                    isSelectableInOfferings: category.isSelectableInOfferings
                }
            }),
            notificationPeriod: {
                'start': {
                    'hours': parseInt(this.notificationPeriod.start.substr(0,2)),
                    'minutes': parseInt(this.notificationPeriod.start.substr(3,2)),
                },
                'end': {
                    'hours': parseInt(this.notificationPeriod.end.substr(0,2)),
                    'minutes': parseInt(this.notificationPeriod.end.substr(3,2)),
                },
            },
            instructorNameVisibility: this.instructorNameVisibility
        };
    }

    isValidInstructorNameVisibility() {
        return this.instructorNameVisibility === ClubOfferingSettings.INSTRUCTOR_NAME_VISIBILITY_FIRST_AND_LAST_NAME
            || this.instructorNameVisibility === ClubOfferingSettings.INSTRUCTOR_NAME_VISIBILITY_FIRST_NAME_ONLY
            || this.instructorNameVisibility === ClubOfferingSettings.INSTRUCTOR_NAME_VISIBILITY_FIRST_NAME_AND_FIRST_LETTER_OF_LAST_NAME;
    }
}
